
import { PATIENT_STAFF } from '../apiConstant'; 
import BaseApi from 'api/baseApi';

class PatientStaffApi extends BaseApi {
    getList(body: {
        per?: number,
        page?: number,
        fullname?: string,
        status?: string,
        sortKey?: string,
        order?: string,
        care_plan_date?: string,
        year_month_payment?: string,
    }) {
        return this.get(PATIENT_STAFF, body);
    }
    getDetail(id: any) {
        return this.get(`${PATIENT_STAFF}/${id}`);
    }

}
export default PatientStaffApi;
